export default __webpack_public_path__ + "static/media/scheduled-cl.0e93d08d.svg";